import React from "react";
import HybridRooms from "./HybridRooms";
import HybridSettings from "./HybridSettings";
import translate from "../Translate";
import {observer} from "mobx-react";

const HybridProctoring = observer(class HybridProctoring extends React.Component {
        constructor() {
            super();

            // Set the initial state
            this.state = {
                createNew: false,
            };
        }

      render () {
            const { createNew } = this.state;

            if (!createNew) {
                return (
                    <HybridRooms
                        setCreateNew={(boolean) => this.setState({createNew: boolean})}
                        {...this.props}
                    />
                );
            } else {
                return (
                    <HybridSettings
                        setCreateNew={(boolean) => this.setState({createNew: boolean})}
                        {...this.props}
                    />
                );
            }
        }
    });

export default translate("HybridProctoring")(HybridProctoring);


// WEBPACK FOOTER //
// ./src/app/components/Hybrid/HybridProctoring.js